'use strict';

export default function f($rootScope, $window, favicon, title, sounds) {
  'ngInject';

  function notify() {
    sounds.playNotification();
    favicon.notifyFav();
    title.notifyTitle();
  }

  function read() {
    favicon.readFav();
    title.readTitle();
  }

  return {
    visible: true,
    supportsNotifications: false,
    unread: false,

    notify() {
      notify();

      if (!this.checkForNotificationSupport()) {
        return;
      }

      if (Notification.permission === 'granted') {
        this.showNotification();
        return;
      }

    },

    showNotification() {
      var options = {
        icon: require('../../images/showaround_logo@2x.png'),
        badge: require('../../images/showaround_logo@2x.png'),
        tag: 'general-message-notification',
      };
      var title = 'You received a new message on Showaround.';
      try {
        new Notification(title, options);
      } catch (e) {
        //
      }
    },

    askForNotificationPermissions() {
      if (!this.isNewNotificationSupported()) {
        return;
      }

      if (Notification.permission === 'default') {
        Notification.requestPermission();
      }
    },

    checkForNotificationSupport() {
      if (this.isNewNotificationSupported()) {
        this.supportsNotifications = true;
        return true;
      }

      return false;
    },

    isNewNotificationSupported() {
      if (!window.Notification || !Notification.requestPermission) {
        return false;
      }
      if (Notification.permission == 'granted') {
        return true;
      }
      try {
        new Notification('');
      } catch (e) {
        if (e.name == 'TypeError') {
          return false;
        }
      }

      return true;
    },

    init() {
      $window.onblur = () => {
        this.visible = false;
      };

      $window.onfocus = () => {
        this.visible = true;
        if (this.unread) {
          read();
          this.unread = false;
        }
      };

      $rootScope.$on('socket:unreadConversationId', () => {
        if (!this.visible) {
          this.notify();
          this.unread = true;
        }
      });

      this.checkForNotificationSupport();
      this.askForNotificationPermissions();
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/services/notification.js